import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars

const Table = ({title, headers, rows}) => {
    return (
        <div className="responsive-table">
            <h3>{title}</h3>
            <table className="default-table" cellSpacing="0" cellPadding="0">
                <thead>
                    <tr>
                        {headers.map( (header) => {
                            return <th className="col"> {header} </th>;
                        },
                        )}
                    </tr>
                </thead>
                {rows.map( (row) => {
                    return (
                        <tbody>
                            <tr>
                                {row.map( (cell, i) => {
                                    if (i === 0) {
                                        return (
                                            <td><b>{cell}</b></td>
                                        );
                                    } else {
                                        return (
                                            <td>{cell}</td>
                                        );
                                    }
                                },

                                )}
                            </tr>
                        </tbody>
                    );
                })}
            </table>
        </div>
    );
};

export default Table;
